/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AuthSessionStatusEnum {
    ONLINE = 'online',
    OFFLINE = 'offline',
    BLOCKED = 'blocked',
}